module.exports = __webpack_public_path__ + "static/media/injuredAboveHeart.0ab2e188.mp3";